import { render, staticRenderFns } from "./DeliveryPointStatusChart.vue?vue&type=template&id=618a9952"
import script from "./DeliveryPointStatusChart.vue?vue&type=script&lang=js"
export * from "./DeliveryPointStatusChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports